import React from 'react';
import Body from './body';
import Modal from 'cccisd-modal';

export default props => (
    <Modal trigger={props.trigger} title="Vacation Report" size="large">
        <Body />
    </Modal>
);
